import { __ } from '@wordpress/i18n';
import React from 'react';
import { useStoreValue } from '../../../../store';

const WidgetProjects = () => {
    const projects = useStoreValue('projects');
    return(
        <div className="appDashboard__widget">
            <div className="appDashboard__widgetTitle">
                <h2>{__('Progetti', 'soundbetween')}</h2>
            </div>
            <ul>
                <li><span>{projects.length}</span> {__('Progetti in Corso', 'soundbetween')}</li>
                <li><span>0</span> {__('Progetti Conclusi', 'soundbetween')}</li>
            </ul>
        </div>
    )
}

export default WidgetProjects;